import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetConceptosTramitesDisponibles } from '../../shared/interfaces/database/liquidacion';

@Injectable({
  providedIn: 'root'
})
export class ConceptosTramitesService {
  private readonly baseUrl = `${environment.apiUrl}/api/conceptos-tramites`;

  constructor(private readonly http: HttpClient) { }

  getConceptosTramitesDisponibles(tipoTramiteId?: number): Observable<IGetConceptosTramitesDisponibles[]> {
    let params = new HttpParams();
    if (tipoTramiteId) {
      params = params.set('tipoTramiteId', tipoTramiteId);
    }
    return this.http.get<IGetConceptosTramitesDisponibles[]>(`${this.baseUrl}/disponibles`, { params });
  }
}
